// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-2f016d44]{font-family:Inter,sans-serif;font-weight:400;font-style:normal;font-variation-settings:\"slnt\" 0}.frisbuy-gallery-navigation[data-v-2f016d44]{top:50%}.frisbuy-gallery-navigation .frisbuy-button-arrow[data-v-2f016d44]{padding:4px 6px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
